module.exports = __webpack_public_path__ + "img/part-1-title.f359c3fe.png";